import ViewController from "core/views/view.controller";
import Vehicle from "../../model/vehicle.model";
import {BookingsFilter} from "../../services/bookings.service";

export default class VehicleDetailsCtrl extends ViewController {
    static $inject = ['$scope', '$state', 'Vehicles', 'Bookings', 'settings'];

    constructor() {
        super(...arguments);
        this.vehicle = null;
        this.vehicleChecks = [];
        this.lastVehicleChecks = null;
        this.bookings = [];
    }

    $onViewBeforeEnter() {
        this.loadVehicle(this.$state.params.vehicleId);
        this.loadVehicleChecks(this.$state.params.vehicleId);
        this.loadBookings(this.$state.params.tagNumber);
    }

    loadVehicle(vehicleId) {
        this.Vehicles.get(vehicleId).then((vehicle)=> {
            this.vehicle = vehicle;
        });
    }

    loadVehicleChecks(vehicleId) {
        this.Vehicles.allVehicleChecks(vehicleId).then((vehicleChecks)=> {
            this.vehicleChecks = vehicleChecks;

            if(vehicleChecks.length > 0){
                this.lastVehicleChecks = vehicleChecks;
            }
        });
    }

    loadBookings(tagNumber) {
        var self = this;

        var bookingsFilter = new BookingsFilter;
        bookingsFilter.sortType = 'startDate';
        bookingsFilter.sortType = BookingsFilter.Sort.ASC;
        bookingsFilter.max = 3;
        bookingsFilter.search = Vehicle.tagNumberUnformatted(tagNumber);

        var branch = this.settings.branch;
        if (branch && branch.id) {
            bookingsFilter.branchId = branch.id;
        }

        this.Bookings.find(bookingsFilter).then((result)=> {
            self.bookings = result.data;
        });
    }

}




// WEBPACK FOOTER //
// ./src/modules/main/views/vehicle-details/vehicle-details.controller.js